"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDefaultNode = exports.setDefaultNode = void 0;
var defaultNode = null;

var setDefaultNode = function setDefaultNode(node) {
  defaultNode = node;
};

exports.setDefaultNode = setDefaultNode;

var getDefaultNode = function getDefaultNode() {
  return defaultNode || document.body;
};

exports.getDefaultNode = getDefaultNode;